import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import visualNovelGameHtml from './visualNovelGameHtml';

/**
 * Puppy & Pipsqueak — a self-contained, browser-playable visual novel.
 *
 * Route: /visual-novel (wrapped in ProtectedRoute in App.js)
 * Game runs entirely in the iframe; it never calls your FastAPI backend.
 * Browser-local save slots are handled by the game's own localStorage code.
 */
export default function VisualNovel() {
  const navigate = useNavigate();
  const [immersive, setImmersive] = useState(false);

  return (
    <main style={{
      position: 'fixed', inset: 0,
      display: 'flex', flexDirection: 'column',
      background: '#0e0b0f', color: '#e8ddd0',
      fontFamily: "'DM Sans', sans-serif", overflow: 'hidden',
    }}>
      {!immersive && (
        <header style={{
          flexShrink: 0, display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', gap: 12, padding: '12px 18px',
          borderBottom: '1px solid rgba(201,147,90,0.16)',
          background: 'linear-gradient(180deg, #19121c, #0e0b0f)',
        }}>
          <button onClick={() => navigate('/companions')} style={navButton}>
            ← <span style={{ marginLeft: 4 }}>reverie</span>
          </button>
          <div style={{ textAlign: 'center', minWidth: 0 }}>
            <div style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontStyle: 'italic', fontSize: 'clamp(16px, 2.7vw, 25px)',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>puppy <span style={{ color: '#d4a0b5' }}>&</span> pipsqueak</div>
            <div style={{ fontSize: 10, letterSpacing: '0.08em', color: '#8a7466' }}>
              our little visual novel ♡
            </div>
          </div>
          <button onClick={() => setImmersive(true)} style={navButton}>
            <span aria-hidden="true">⛶</span> <span style={{ marginLeft: 4 }}>expand</span>
          </button>
        </header>
      )}
      <div style={{
        position: 'relative', flex: 1, minHeight: 0,
        padding: immersive ? 0 : '8px',
        background: '#0e0b0f',
      }}>
        <iframe
          title="Puppy & Pipsqueak — interactive visual novel"
          srcDoc={visualNovelGameHtml}
          style={{
            width: '100%', height: '100%', display: 'block',
            border: immersive ? 'none' : '1px solid rgba(201,147,90,0.15)',
            borderRadius: immersive ? 0 : 8,
            background: '#087d81',
          }}
        />
        {immersive && (
          <button
            type="button"
            onClick={() => setImmersive(false)}
            aria-label="exit expanded game view"
            style={{
              position: 'absolute', zIndex: 10, right: 12, bottom: 12,
              ...navButton,
              border: '1px solid rgba(255,255,255,0.55)',
              background: 'rgba(24,16,35,0.88)',
              padding: '10px 14px', borderRadius: 8,
            }}
          >exit expanded view ↙</button>
        )}
      </div>
    </main>
  );
}

const navButton = {
  background: 'transparent', color: '#dbbcad',
  border: '1px solid rgba(201,147,90,0.25)',
  padding: '9px 12px', borderRadius: 9,
  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  fontSize: 12, whiteSpace: 'nowrap',
};
